export default __webpack_public_path__ + "static/grafika-1-e5661275a03b8c4feba3ea39040ef6c1.png";